
  export default {
    mounted() {
      // A file input fires a bubbling `cancel` when its picker is dismissed, which arrives here
      // looking exactly like the dialog's own. Only the dialog and the element it sits in can
      // ask to close; anything a descendant control raises is passing through.
      const dialog = this.el.querySelector(":scope > dialog");
      const forward = ({ target }) => {
        if (target !== this.el && target !== dialog) return;
        const event = this.el.dataset.onClose;
        if (!event) return;
        // Escape and a backdrop click come through here rather than the close button, so they
        // need the same phx-target the button carries or they land on the page instead of the
        // LiveComponent that owns the dialog.
        const phxTarget = this.el.dataset.onCloseTarget;
        if (phxTarget) {
          this.pushEventTo(phxTarget, event, { id: this.el.id });
        } else {
          this.pushEvent(event, { id: this.el.id });
        }
      };
      this.el.addEventListener("close", forward);
      this.el.addEventListener("cancel", forward);
    }
  }
